import { render, staticRenderFns } from "./statisticsSolid.vue?vue&type=template&id=64634558&"
import script from "./statisticsSolid.vue?vue&type=script&lang=js&"
export * from "./statisticsSolid.vue?vue&type=script&lang=js&"
import style0 from "./statisticsSolid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports